module.exports = __webpack_public_path__ + "static/metadonors-4ecd69603394018fef773ddda263b317.png";